var map = {
	"./Basic_DMP_OCA_package_v6.json": 2412,
	"./DataCite_OCA_package.json": 3168,
	"./OpenAIRE_OCA_package_Original.json": 5569,
	"./Project_OCA_package.json": 7594,
	"./Project_OCA_package.v1.json": 7621,
	"./Project_RAiD_schema.json": 2126,
	"./dataset_catalogue_record_OCA_package.json": 9173,
	"./q-002-test.json": 3425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9079;